var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loginEnabled
    ? _c(
        "b-form",
        [
          _c(
            "b-row",
            [
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.email"),
                    error: _vm.$v.user.UserName,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: { type: "text", placeholder: _vm.$t("auth.email") },
                    on: { enter: _vm.submitForm },
                    model: {
                      value: _vm.user.UserName,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "UserName", $$v)
                      },
                      expression: "user.UserName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "NextFormGroup",
                {
                  attrs: {
                    title: _vm.$t("auth.password"),
                    error: _vm.$v.user.Password,
                    md: "12",
                    lg: "12"
                  }
                },
                [
                  _c("NextInput", {
                    attrs: {
                      type: "password",
                      placeholder: _vm.$t("auth.password")
                    },
                    on: { enter: _vm.submitForm },
                    model: {
                      value: _vm.user.Password,
                      callback: function($$v) {
                        _vm.$set(_vm.user, "Password", $$v)
                      },
                      expression: "user.Password"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "text-center" },
            [
              _c(
                "b-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { id: "loginButton", type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm()
                        }
                      }
                    },
                    [
                      _c("span", { attrs: { id: "loginLoaderText" } }, [
                        _vm._v(_vm._s(_vm.$t("auth.login")))
                      ]),
                      _vm._v(" "),
                      _c("b-spinner", {
                        staticStyle: {
                          display: "none",
                          "text-align": "center"
                        },
                        attrs: { id: "loginLoader", label: "Spinning" }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "my-3", attrs: { cols: "12" } },
                [
                  _c(
                    "router-link",
                    { attrs: { to: { name: "ForgotPassword" } } },
                    [_vm._v(_vm._s(_vm.$t("auth.forgotPassword")))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.loginError
                ? _c(
                    "b-col",
                    { staticClass: "my-4", attrs: { cols: "12" } },
                    [
                      _c(
                        "b-alert",
                        { attrs: { show: "", variant: "danger" } },
                        [_vm._v(_vm._s(_vm.loginError))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "mt-3 m-auto", attrs: { cols: "9" } },
                [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.$t("auth.information")) }
                  })
                ]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45cdf4fc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45cdf4fc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/login.vue
// module id = null
// module chunks = 